/**
 * ESSENTIA LUXURY — Cart Drawer
 * Slide-in cart drawer (desktop) / bottom-sheet (mobile).
 * Opens automatically after a successful add-to-cart via the
 * 'cart:refresh' CustomEvent dispatched by the section script.
 *
 * @version 1.0.0
 */
(function () {
  'use strict';

  /* ── Helpers ────────────────────────────────────────────────── */
  function money(cents) {
    if (!cents && cents !== 0) return '';
    var d = (cents / 100).toFixed(2);
    return '$' + d.replace(/\.00$/, '');
  }

  function esc(str) {
    var el = document.createElement('span');
    el.textContent = str || '';
    return el.innerHTML;
  }

  /* ── Build DOM ──────────────────────────────────────────────── */
  var overlay = document.createElement('div');
  overlay.className = 'es-cart-overlay';
  overlay.id = 'es-cart-overlay';

  var drawer = document.createElement('div');
  drawer.className = 'es-cart-drawer';
  drawer.id = 'es-cart-drawer';
  drawer.setAttribute('role', 'dialog');
  drawer.setAttribute('aria-modal', 'true');
  drawer.setAttribute('aria-label', 'Shopping cart');
  drawer.innerHTML = [
    '<div class="es-cart-drawer__header">',
    '  <div>',
    '    <h3 class="es-cart-drawer__title">Your Collection</h3>',
    '    <span class="es-cart-drawer__count" id="es-drawer-count"></span>',
    '  </div>',
    '  <button class="es-cart-drawer__close" id="es-drawer-close" type="button" aria-label="Close cart">',
    '    <svg viewBox="0 0 14 14"><line x1="2" y1="2" x2="12" y2="12"/><line x1="12" y1="2" x2="2" y2="12"/></svg>',
    '  </button>',
    '</div>',
    '<div class="es-cart-drawer__body" id="es-drawer-body"></div>',
    '<div class="es-cart-drawer__footer" id="es-drawer-footer" style="display:none;">',
    '  <div class="es-cart-drawer__subtotal">',
    '    <span class="es-cart-drawer__subtotal-label">Subtotal</span>',
    '    <span class="es-cart-drawer__subtotal-value" id="es-drawer-subtotal"></span>',
    '  </div>',
    '  <p class="es-cart-drawer__note">Shipping calculated at checkout</p>',
    '  <a href="/checkout" class="es-cart-drawer__checkout">Proceed to Checkout</a>',
    '  <button class="es-cart-drawer__continue" id="es-drawer-continue" type="button">Continue Shopping</button>',
    '</div>'
  ].join('\n');

  document.body.appendChild(overlay);
  document.body.appendChild(drawer);

  var drawerBody     = document.getElementById('es-drawer-body');
  var drawerFooter   = document.getElementById('es-drawer-footer');
  var drawerCount    = document.getElementById('es-drawer-count');
  var drawerSubtotal = document.getElementById('es-drawer-subtotal');

  /* ── Open / Close ───────────────────────────────────────────── */
  function openDrawer() {
    document.body.classList.add('es-drawer-open');
    overlay.classList.add('is-open');
    drawer.classList.add('is-open');
    loadCart();
  }

  function closeDrawer() {
    document.body.classList.remove('es-drawer-open');
    overlay.classList.remove('is-open');
    drawer.classList.remove('is-open');
  }

  document.getElementById('es-drawer-close').addEventListener('click', closeDrawer);
  document.getElementById('es-drawer-continue').addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });

  /* ── Fetch & Render ─────────────────────────────────────────── */
  function loadCart() {
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {
        drawerBody.innerHTML = '<p style="padding:24px;text-align:center;color:var(--es-ink-light);">Could not load cart.</p>';
      });
  }

  function renderCart(cart) {
    var items = cart.items || [];
    drawerCount.textContent = items.length + ' item' + (items.length !== 1 ? 's' : '');

    if (items.length === 0) {
      drawerBody.innerHTML = [
        '<div class="es-cart-drawer__empty">',
        '  <svg viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">',
        '    <path d="M2 2 H8 L13 28 H32 L37 10 H11" stroke-linecap="round" stroke-linejoin="round"/>',
        '    <circle cx="16" cy="34" r="3"/><circle cx="29" cy="34" r="3"/>',
        '  </svg>',
        '  <p>Your collection is empty</p>',
        '  <a href="/collections/all">Explore Fragrances</a>',
        '</div>'
      ].join('\n');
      drawerFooter.style.display = 'none';
      return;
    }

    drawerBody.innerHTML = items.map(function (item, i) {
      var rawImg = (item.featured_image && item.featured_image.url) || item.image || '';
      var imgSrc = rawImg ? rawImg + (rawImg.indexOf('?') > -1 ? '&' : '?') + 'width=180' : '';

      return [
        '<div class="es-cart-item" data-key="' + esc(item.key) + '">',
        '  <div class="es-cart-item__img">',
             imgSrc ? '<img src="' + esc(imgSrc) + '" alt="' + esc(item.product_title) + '" width="80" height="80" loading="lazy">' : '',
        '  </div>',
        '  <div class="es-cart-item__info">',
        '    <span class="es-cart-item__name">' + esc(item.product_title) + '</span>',
        '    <span class="es-cart-item__variant">' + esc(item.variant_title || '') + '</span>',
        '    <div class="es-cart-item__qty">',
        '      <button type="button" data-action="decrease" data-key="' + esc(item.key) + '" aria-label="Decrease quantity">\u2212</button>',
        '      <span>' + item.quantity + '</span>',
        '      <button type="button" data-action="increase" data-key="' + esc(item.key) + '" aria-label="Increase quantity">+</button>',
        '    </div>',
        '    <button type="button" class="es-cart-item__remove" data-action="remove" data-key="' + esc(item.key) + '">Remove</button>',
        '  </div>',
        '  <span class="es-cart-item__price">' + money(item.final_line_price) + '</span>',
        '</div>'
      ].join('\n');
    }).join('');

    drawerSubtotal.textContent = money(cart.total_price);
    drawerFooter.style.display = '';

    /* Bind quantity / remove buttons */
    var buttons = drawerBody.querySelectorAll('[data-action]');
    for (var b = 0; b < buttons.length; b++) {
      buttons[b].addEventListener('click', handleCartAction);
    }
  }

  function handleCartAction(e) {
    var btn    = e.currentTarget;
    var action = btn.getAttribute('data-action');
    var key    = btn.getAttribute('data-key');
    var itemEl = btn.closest('.es-cart-item');
    var qtyEl  = itemEl ? itemEl.querySelector('.es-cart-item__qty span') : null;
    var qty    = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;

    if (action === 'increase')      qty++;
    else if (action === 'decrease') qty = Math.max(0, qty - 1);
    else if (action === 'remove')   qty = 0;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      renderCart(cart);
      updateHeaderCount(cart.item_count);
    })
    .catch(function () { /* silent */ });
  }

  function updateHeaderCount(n) {
    var els = document.querySelectorAll('[data-cart-count], .cart-count, #cart-count, .cart__count');
    for (var i = 0; i < els.length; i++) els[i].textContent = n;
  }

  /* ── Listen for the section's add-to-cart success event ──────── */
  document.addEventListener('cart:refresh', function () {
    openDrawer();
  });

  /* ── Public API (optional) ──────────────────────────────────── */
  window.EssentiaCart = { open: openDrawer, close: closeDrawer, refresh: loadCart };
})();
